import React from 'react';
import { Star } from 'lucide-react';

export default function StarRating({ value = 5, size = 16, color = '#FFC61A', className = '' }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          style={{ width: size, height: size }}
          className={i <= Math.round(value) ? '' : 'opacity-25'}
          color={color}
          fill={i <= Math.round(value) ? color : 'transparent'}
        />
      ))}
    </div>
  );
}
